import * as actions from '../constants/weekApprovalUiActions';

const weekApprovalUiActions = {

  toggleMyProjectOpen(projectKey) {
    return actions.toggleMyProjectOpen(projectKey);
  },

  toggleOtherProjectOpen(projectKey) {
    return dispatch => {
      dispatch(actions.toggleOtherProjectOpen(projectKey));
    };
  },

  toggleMyTaskOpen(projectKey, taskKey) {
    return dispatch => {
      dispatch(actions.toggleMyTaskOpen(projectKey, taskKey));
    };
  },

  toggleOtherTaskOpen(projectKey, taskKey) {
    return dispatch => {
      dispatch(actions.toggleOtherTaskOpen(projectKey, taskKey));
    };
  },

  unfoldMyProject(projectKey) {
    return actions.unfoldMyProject(projectKey);
  },

  unfoldOtherProject(projectKey) {
    return actions.unfoldOtherProject(projectKey);
  },

  foldMyProject(projectKey) {
    return dispatch => {
      dispatch(actions.foldMyProject(projectKey));
    };
  },

  foldOtherProject(projectKey) {
    return dispatch => {
      dispatch(actions.foldOtherProject(projectKey));
    };
  },

  foldMyTask(projectKey, taskKey) {
    return dispatch => {
      dispatch(actions.foldMyTask(projectKey, taskKey));
    };
  },

  unfoldMyTask(projectKey, taskKey) {
    return actions.unfoldMyTask(projectKey, taskKey);
  },

  foldOtherTask(projectKey, taskKey) {
    return dispatch => {
      dispatch(actions.foldOtherTask(projectKey, taskKey));
    };
  },

  unfoldOtherTask(projectKey, taskKey) {
    return dispatch => {
      dispatch(actions.unfoldOtherTask(projectKey, taskKey));
    };
  },

  resetMyProjectOpen() {
    return dispatch => {
      dispatch(actions.resetMyProjectOpen());
    };
  },

  resetOtherProjectOpen() {
    return dispatch => {
      dispatch(actions.resetOtherProjectOpen());
    };
  },

  resetMyTaskOpen() {
    return dispatch => {
      dispatch(actions.resetMyTaskOpen());
    };
  },

  resetOtherTaskOpen() {
    return dispatch => {
      dispatch(actions.resetOtherTaskOpen());
    };
  },

  resetAllProjectsAndTasks() {
    return dispatch => {
      dispatch(actions.resetMyProjectOpen());
      dispatch(actions.resetOtherProjectOpen());
      dispatch(actions.resetMyTaskOpen());
      dispatch(actions.resetOtherTaskOpen());
    }
  },

  giveappropriatename() {
    return dispatch => {

    }
  }
};

export default weekApprovalUiActions;



/** WEBPACK FOOTER **
 ** ./src/app/actions/weekApprovalUiActionCreators.js
 **/